module.exports = __webpack_public_path__ + "static/media/PDF19.03854147.pdf";